module.exports = {"validation":{"required":"Это поле обязательно","email":"Недействительный адрес электронной почты"}}